export const html = "<p>Visit the Mikayelyan family cheese farm.</p>\n";
export const leadHtml = "<p>Visit the Mikayelyan family cheese farm.</p>\n";
export const bodyHtml = "";
export const metaText = "Visit the Mikayelyan family cheese farm.";